import { logError, logWarning } from "../LocalLogger";
interface StringRecord {
	id?: number;
	content: string;
}
export class LocalLargeStorage {
	dbName: string;
	version: number;
	db: IDBDatabase | null = null;
	constructor(dbName: string = "largeStringDB", version: number = 1) {
		this.dbName = dbName;
		this.version = version;
	}
	async initDB() {
		if (this.db) {
			return;
		}
		const db = await new Promise((resolve, reject) => {
			const request = indexedDB.open(this.dbName, this.version);

			request.onerror = (event) => {
				logError("Database error:", (event.target as IDBRequest).error);
				reject((event.target as IDBRequest).error);
			};

			request.onsuccess = (event) => {
				// logDebug('Database opened successfully');
				resolve((event.target as IDBRequest).result);
			};

			request.onupgradeneeded = (event) => {
				const db = (event.target as IDBRequest).result;
				db.createObjectStore("strings");
			};
		});
		this.db = db as IDBDatabase;
	}

	async setItem(key: string, content: string): Promise<void> {
		try {
			if (!this.db) {
				await this.initDB();
			}
			const transaction = this.db!.transaction(["strings"], "readwrite");
			const objectStore = transaction.objectStore("strings");
			const stringRecord: StringRecord = { content };

			const request = objectStore.put(stringRecord, key);

			await new Promise<void>((resolve, reject) => {
				request.onsuccess = () => {
					// logDebug('String added to the database successfully');
					resolve();
				};

				request.onerror = (event) => {
					logError("Failed to add string:", (event.target as IDBRequest).error);
					reject((event.target as IDBRequest).error);
				};
			});
		} catch (error) {
			logError("Error adding string to DB:", error);
		}
	}

	async getItem(key: string): Promise<string> {
		try {
			if (!this.db) {
				await this.initDB();
			}
			const transaction = this.db!.transaction(["strings"], "readonly");
			const objectStore = transaction.objectStore("strings");
			const request = objectStore.get(key);
			const ret = await new Promise<string>((resolve, reject) => {
				request.onsuccess = (event) => {
					const stringRecord = (event.target as IDBRequest).result as StringRecord;
					if (stringRecord) {
						resolve(stringRecord.content);
					} else {
						// logWarning('No string found with the given id');
						resolve("");
					}
				};

				request.onerror = (event) => {
					logError("Failed to retrieve string:", (event.target as IDBRequest).error);
					reject((event.target as IDBRequest).error);
				};
			});
			return ret;
		} catch (error) {
			logError("Error retrieving string from DB:", error);
		}
		return "";
	}

	getItemSynced(key: string): string | undefined {
		logWarning("call this function on your own risk, it will block the main thread until the promise is resolved");
		let result: string | undefined;
		let error: any;

		const promise = this.getItem(key)
			.then((data) => {
				result = data;
			})
			.catch((err) => {
				error = err;
			});

		const loop = setInterval(() => {
			if (result !== undefined || error !== undefined) {
				clearInterval(loop);
			}
		}, 10);

		while (result === undefined && error === undefined) {
			// Busy-wait loop to block execution until the promise is resolved
		}

		if (error) {
			throw error;
		}

		return result;
	}
}

export const localLargeStorage = new LocalLargeStorage();
